
import { Navigate } from "react-router";
import { useEffect, type JSX } from "react";
import { useForm } from "react-hook-form"
import { FloatingInputBootStrap } from "../Common/FloatingInputBootstrap";
import { useAddTraductionsMutation } from "../../stores/OkOkStore";
import type { ResponseError } from "../../types/CommonReponse";

import { useTrads } from "../../contexts/trads/useTrads";
import type { TraductionsInsert } from "../../types/Traductions";

export function  TraductionsInsertForm (): JSX.Element {
    const  traductions:TraductionsInsert={name:"",value:"",nl:"",en:"",explication:""};
    const [addTraductions,result]=useAddTraductionsMutation();
    const { register, handleSubmit,setError, formState: { errors } } = useForm({
        defaultValues:traductions,
        //shouldUseNativeValidation: true,
        mode:'onBlur',
    });
    const {translate,setLoaded}=useTrads();
    useEffect(()=>{
        if(result.error && 'data' in result.error) {
            const server_error:ResponseError=result.error as ResponseError;
            const errors =server_error.data.error;
            if(errors){
                for (const i in errors) {
                        // @ts-expect-error i est connu!
                        setError(i, {type:'validate',message: translate(errors[i])});  
                }
                result.reset();
            }
        }
        if(result.isSuccess){
            setLoaded(false);
        }
    },[setError,result,translate,setLoaded]);
    
    return (
        result.isSuccess ? <Navigate to={`/traductions/${result.data.id.toString()}`} state={{"modified":true}}></Navigate>  :(
        result.error ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p> :
        result.isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :
        <form className="row" onSubmit={(event) => void handleSubmit(addTraductions)(event)}>
            <div className="col-12  mb-3">
                <FloatingInputBootStrap
                    name="name"
                    label={translate('traduction_nom')}
                    type="text"
                    errors={errors}
                    registerOutput= {register("name", {
                        required: translate("traduction_error_nom_requis"),
                        minLength: 2
                    })} 
                />

            </div>
            <div className="col-12  mb-3">
                <FloatingInputBootStrap
                    name="value"
                    label={translate('traduction_fr')}
                    type="text"
                    errors={errors}
                    registerOutput= {register("value" )} 
                />

            </div>
            {/*
            <div className="col-12  mb-3">
                <FloatingInputBootStrap
                    name="nl"
                    label={translate('traduction_nl')}
                    type="text"
                    errors={errors}
                    registerOutput= {register("nl" )} 
                />

            </div>

            <div className="col-12  mb-3">
                <FloatingInputBootStrap
                    name="en"
                    label={translate('traduction_en')}
                    type="text"
                    errors={errors}
                    registerOutput= {register("en" )} 
                />

            </div>
            */}
            <div className="col-12  mb-3">
                <FloatingInputBootStrap
                    name="explication"
                    label={translate('traduction_explication')}
                    type="text"
                    errors={errors}
                    registerOutput= {register("explication" )} 
                />

            </div>


            <div className="col-4  mb-3">
                <button type="submit">{translate('form_submit')}</button>
            </div>
        </form>
        )
    )
};

export default TraductionsInsertForm;

